import React from 'react';
import Header from './Header';
import ResultDonors from './ResultDonors';
import Footer from '../../components/Footer';
import { useTitle } from '../../hooks/useTitle';

const SearchResult = () => {
  useTitle('Ton Bébé | こだわり検索結果');

  return (
    <div>
      <Header />
      <main className="sub">
        <section className="archive_result">
          <h1 className="sec_title">こだわり検索結果</h1>
          <ResultDonors />
        </section>
      </main>
      <Footer />
    </div>
  );
}

export default SearchResult;
